// Greek mobile phone helpers. Accepts only 10-digit numbers starting with 69.
export const GR_PHONE_REGEX = /^69\d{8}$/;

export function normalizePhone(str) {
  return (str || "").replace(/\D/g, "");
}

export function isValidGrPhone(str) {
  return GR_PHONE_REGEX.test(normalizePhone(str));
}

// Basic email validator (form-level only; backend also validates with EmailStr).
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(str) {
  return EMAIL_REGEX.test((str || "").trim());
}
